import { types } from 'mobx-state-tree';
import PlaylistResult from './PlaylistResult';

const SectionResult = types.model('SectionResult', {
  sectionId: types.string,
  playlists: types.optional(types.array(PlaylistResult),[])
});

export default SectionResult;
